import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../root-saga/root-state';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.workspace || initialState;

export const selectProject = createSelector(
  [selectSlice],
  (s) => s.project,
);
export const selectLoadingProject = createSelector(
  [selectSlice],
  (s) => s.loadingProject,
);
export const selectSelectedLanguage = createSelector(
  [selectSlice],
  (s) => s.selectedLanguage,
);
export const selectKeys = createSelector([selectSlice], (s) => s.keys);
export const selectKeysMeta = createSelector([selectSlice], (s) => s.keysMeta);
export const selectKeysLoading = createSelector(
  [selectSlice],
  (s) => s.keysLoading,
);
export const selectKeysSearch = createSelector(
  [selectSlice],
  (s) => s.keysSearch,
);
export const selectTranslations = createSelector(
  [selectSlice],
  (s) => s.translations,
);
export const selectTranslationsLoading = createSelector(
  [selectSlice],
  (s) => s.translationsLoading,
);
export const selectBusyKeyId = createSelector(
  [selectSlice],
  (s) => s.busyKeyId,
);
export const selectImporting = createSelector(
  [selectSlice],
  (s) => s.importing,
);
export const selectActiveJob = createSelector(
  [selectSlice],
  (s) => s.activeJob,
);
export const selectJobLocked = createSelector([selectActiveJob], (job) =>
  Boolean(job && (job.status === 'QUEUED' || job.status === 'RUNNING')),
);
export const selectApiKeys = createSelector([selectSlice], (s) => s.apiKeys);
export const selectApiKeysLoading = createSelector(
  [selectSlice],
  (s) => s.apiKeysLoading,
);
export const selectNewApiKeySecret = createSelector(
  [selectSlice],
  (s) => s.newApiKeySecret,
);
